import { render, staticRenderFns } from "./KpiRevenue.vue?vue&type=template&id=73a2166c"
import script from "./KpiRevenue.vue?vue&type=script&lang=js"
export * from "./KpiRevenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports